/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { createObservableDataAction, IAction, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';

import { IStoreSelectorStateManager } from './i-store-selection-state-manager';
import { MapStoreSelectorStateManager } from './map-store-selector-state-manager';

export function createStoreSelectorStateInput(result: IStoreSelectorStateManager): GenericInput<IStoreSelectorStateManager> {
    return new GenericInput<IStoreSelectorStateManager>('mapSSSM', result, 'IStoreSelectorStateManager');
}

const createStoreSelectorStateInputInternal = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return createStoreSelectorStateInput(new MapStoreSelectorStateManager());
};

export const getGenericActionDataAction = createObservableDataAction({
    action: <IAction<IStoreSelectorStateManager>>getGenericAction,
    input: createStoreSelectorStateInputInternal
});

export default getGenericActionDataAction;
